import { useEffect, useRef, useState } from "react"
import useLocalState from "./useLocalState"
import useLoading from "./useLoading"

  // TODO: The index is being called a lot for this.... We should probably just use a set here to be safe, and check if the item exists, only updating the set if the number of items changes.
  // WARNING: If the index gets messed up, we may never find the items efficiently. ONLY UPDATE STATE with functions that will re-index
  // const reIndex = (items) => {
  //   if (!useIndex || !Array.isArray(items)) return;
  //   console.log('REINDEXING')
  //   itemsIndex.current = (items || itemsRef.current).reduce((hash, item, i) => {
  //     hash[item[indexAccessor]] = i
  //     return hash
  //   }, {})
  // }

  // const getIndexed = (id) => {
  //   if (!useIndex) return;
  //   const currentIndex = itemsIndex.current?.[id]
  //   if (typeof currentIndex === 'number') {
  //     const currentItem = itemsRef?.current?.[currentIndex]
  //     if (currentItem?.[indexAccessor] === id) {
  //       return currentItem
  //     }
  //   }
  // }

const useInfiniteLoading = ({ itemName, dataRequest, createSet=false, setAccessor='uuid', afterGetInitialItems }) => {
  const [items, setItems, itemsRef] = useLocalState(`infinite-load-items-${itemName}`, [])
  const { isLoading, isLoadingDelayed, setIsLoading } = useLoading(false) 
  const [noMoreItems, setNoMoreItems] = useState(false)
  const firstRenderRef = useRef(true)
  // const itemsIndex = useRef({})
  const itemsSet = useRef(new Set())
  const listRef = useRef()

  // Reacreates set when the length of items changes
  useEffect(() => {
    if (!createSet || !Array.isArray(items)) return;
    itemsSet.current = itemsRef.current.reduce((set, item) => {
      set.add(item?.[setAccessor])
      return set
    }, new Set())
  }, [items?.length])

  // const getIndexed = (id) => {
  //   if (!useIndex) return;
  //   const currentIndex = itemsIndex.current?.[id]
  //   if (typeof currentIndex === 'number') {
  //     const currentItem = items?.[currentIndex]
  //     if (currentItem?.[indexAccessor] === id) {
  //       return currentItem
  //     }
  //   }
  // }

  const getItems = (options = { offset: 0 }) =>
    new Promise((resolve, reject) => {
      setIsLoading(true)
      return dataRequest({ offset: options?.offset })
        .then(resolve)
        .catch((err) => {
          console.log(err)
          setIsLoading(false)
          reject(err)
        })
    })

  const getInitialItems = () => getItems({ offset: 0 })
    .then((res) => {
      setItems(res.data)
      setIsLoading(false)
      setNoMoreItems(false)
      firstRenderRef.current = false
      if (typeof afterGetInitialItems === 'function') afterGetInitialItems(res.data);
    })

  const getMoreItems = () => getItems({ offset: items?.length })
    .then((res) => {
      setItems(items.concat(res.data))
      setIsLoading(false)
      if (res.data.length < 25) setNoMoreItems(true)
    })

  const prependItem = (newItem) => {
    let newState
    setItems((items) => {
      newState = [newItem, ...items]
      return newState
    })
    return newState
  }

  const appendItem = (newItem) => {
    let newState
    setItems((items) => {
      newState = items?.concat(newItem)
      return newState
    })
    return newState
  }

  const updateItem = (updateCallback) => {
    if (typeof updateCallback !== 'function') {
      return console.error('useInfiniteLoading: function removeItem/updateItem must take a callback')
    }
    let newState
    setItems((items) => {
      newState = updateCallback(items)
      return newState
    })
    return newState
  }

  const removeItem = updateItem;
  
  return {
    items,
    setItems,
    itemsRef,
    itemsSet,
    prependItem,
    appendItem,
    updateItem,
    removeItem,

    noMoreItems,
    setNoMoreItems,

    getItems,
    getInitialItems,
    getMoreItems,

    isLoading,
    isLoadingDelayed,
    setIsLoading,
    
    firstRenderRef,
    listRef,
  }
}

export default useInfiniteLoading
